// extracted by mini-css-extract-plugin
export var dataCell = "_ou-2";
export var dataRow = "_ou-0";
export var headerRow = "_ou-1";